import { render, staticRenderFns } from "./Configuracoes.vue?vue&type=template&id=55c35ea6"
import script from "./Configuracoes.vue?vue&type=script&lang=ts"
export * from "./Configuracoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports